import lightTheme from './light';
import clone from 'clone';

const theme = clone(lightTheme);

export default theme;
